export const WorkstationRepositoryToken = Symbol('WorkstationRepository');
export const AuthenticationToken = Symbol('Authentication');
